<template>
  <div class="main__content content">
    <SpinnerLoading v-if="isLoadingTable" class="loader_center" color="blue" />
    <PacsTable
      :column-captions="columnCaptions"
      :column-names="columnNames"
      :data-rows="dataRows"
      :page-count="1"
      :view-only-mode="true"
    />
  </div>
</template>

<script>
import PacsTable from "@/components/pacs/PacsTable.vue";
import {
  ROUTE_PACS_EDIT_PERIMETER_SECURITY_ANALYTICS,
} from "@/router/names.js";
import {
  ACTION_LOAD_PERIMETER_SECURITY_ANALYTICS_FOR_TABLE,
  CAMERA_PERIMETER_ANALYTICS_STRUCT
} from "@/store/analytics/index.js";
import {entityTableMixin} from "@/components/pacs/mixins.js";

/**
 * Компонент отображения таблицы камер с аналитикой по вторжению зоны.
 */
export default {
  name: "TablePerimeterSecurity",
  mixins: [
    entityTableMixin,
  ],
  components: {
    PacsTable
  },
  data() {
    return {
      entityStruct: CAMERA_PERIMETER_ANALYTICS_STRUCT,
      entityFields: [
        CAMERA_PERIMETER_ANALYTICS_STRUCT.fields.camera_number,
      ],

    };
  },
  methods: {
    /**
     * @see eventTableMixin.methods.loadPage.
     */
    async loadPage() {
      this.isLoadingTable = true;
      try {
        const responseData = await this.$store.dispatch(`analytics/${ACTION_LOAD_PERIMETER_SECURITY_ANALYTICS_FOR_TABLE}`, {
          search: this.searchText,
        });
        this.dataRows = responseData.results.map((rawMaskInfo) => {
          const cameraNumber = rawMaskInfo[CAMERA_PERIMETER_ANALYTICS_STRUCT.fields.camera_number.name],
                paramsRouteEditMaskAnalytics = {name: ROUTE_PACS_EDIT_PERIMETER_SECURITY_ANALYTICS, params: {cameraNumber}};
          return {
            ...this.calcDefaultDataRow(rawMaskInfo),
            [CAMERA_PERIMETER_ANALYTICS_STRUCT.fields.camera_number.name]: {
              type: CAMERA_PERIMETER_ANALYTICS_STRUCT.fields.camera_number.type,
              value: cameraNumber,
              params: paramsRouteEditMaskAnalytics
            },
            [CAMERA_PERIMETER_ANALYTICS_STRUCT.fields.min_object_height.name]: {
              value: rawMaskInfo[CAMERA_PERIMETER_ANALYTICS_STRUCT.fields.min_object_height.name],
            },
          };
        });
      } finally {
        this.isLoadingTable = false;
      }
    },
  },
};
</script>
